import { render, staticRenderFns } from "./SpecialAttributeList.vue?vue&type=template&id=43b19b4e&scoped=true&"
import script from "./SpecialAttributeList.vue?vue&type=script&lang=js&"
export * from "./SpecialAttributeList.vue?vue&type=script&lang=js&"
import style0 from "./SpecialAttributeList.vue?vue&type=style&index=0&id=43b19b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b19b4e",
  null
  
)

export default component.exports